module.exports = __webpack_public_path__ + "media/images/icon__arrow-left-5da89e5b802cf7d3c4dfdd1393a989b2.png";